import { makeFunctionalNext } from '../../definition/resolver';
import { toError, toLoading, toSuccess } from '../../definition/resolverState';
import { RpcError } from './RpcError';
import { ENDPOINT_CONFIG_ARGS, toRpcInputs } from './endpointConfig';
import { Metrics } from '../../../metrics/metrics';
const rpcAttach = (rpc, rpcClient, toInputs) => (params, runtime) => {
  const {
    env: {
      logger
    }
  } = runtime;
  const next = makeFunctionalNext(runtime);
  let pendingRefresh = false;
  const guardedFetch = async () => {
    if (pendingRefresh) {
      logger === null || logger === void 0 || logger.debug('refresh already pending');
      return;
    }
    pendingRefresh = true;
    Metrics.counter('resolver-refresh', {
      transport: 'chirp'
    }).increment();
    logger === null || logger === void 0 || logger.debug('fetching');
    const callSiteError = new Error();
    next(toLoading());
    try {
      const result = await rpcClient.callWithResultUnion(rpc, toInputs(params));
      if (result.type === 'data') {
        logger === null || logger === void 0 || logger.debug('success');
        next(toSuccess(result.data));
      } else {
        logger === null || logger === void 0 || logger.debug('rpc error');
        next(toError(new RpcError(result.rpcError, callSiteError.stack)));
      }
    } catch (error) {
      logger === null || logger === void 0 || logger.debug('error');
      next(toError(error));
    }
    pendingRefresh = false;
  };
  return {
    refresh: () => void guardedFetch(),
    detach: () => {}
  };
};

/**
 * Resolver for a CHIRP RPC. Params are the RPC's request type. For idp-auth
 * services that also accept env/hublet/impersonation params, use
 * `fromIDPAuthRPC`.
 */
export const fromRPC = ({
  rpc,
  rpcClient
}) => ({
  name: rpc.rpcName,
  tags: ['CHIRP', 'promise'],
  attach: rpcAttach(rpc, rpcClient, params => ({
    request: params
  }))
});

/**
 * Resolver for an idp-auth CHIRP RPC. Params are the request type plus the
 * endpoint configuration (env/hublet/impersonation), which are peeled off
 * before calling and folded into the resource's cache identity.
 */
export const fromIDPAuthRPC = ({
  rpc,
  rpcClient
}) => ({
  name: rpc.rpcName,
  tags: ['CHIRP', 'promise'],
  args: ENDPOINT_CONFIG_ARGS,
  attach: rpcAttach(rpc, rpcClient, toRpcInputs)
});